import { Alert, Snackbar } from "@mui/material";
import { toasterStyle } from "./toasterStyle";

function Toaster({
  severity = "success",
  message = "Add your message",
  open = false,
  handleClose = () => {},
}) {
  return (
    <Snackbar
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "top", horizontal: "center" }}
      open={open}
      // eslint-disable-next-line
      key={"top" + "center"}
      onClose={handleClose}
    >
      <Alert
        // @ts-ignore
        severity={severity}
        variant="filled"
        sx={toasterStyle.alertStyle}
        onClose={handleClose}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default Toaster;
